const cleanAddressPart = (value) =>
  value === undefined || value === null
    ? ""
    : String(value).trim().replace(/\s+/g, " ");

const parseCoordinate = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const parsed = Number(String(value).trim().replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};

export const buildApartmentGeocodeAddress = ({
  street,
  streetNumber,
  zip,
  city,
} = {}) => {
  const streetAddress = [cleanAddressPart(street), cleanAddressPart(streetNumber)]
    .filter(Boolean)
    .join(" ");

  return [
    streetAddress,
    cleanAddressPart(zip),
    cleanAddressPart(city),
    "Ελλάδα",
  ]
    .filter(Boolean)
    .join(", ");
};

export const getApartmentAddressKey = (apartment) =>
  buildApartmentGeocodeAddress(apartment)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("el-GR");

export const hasApartmentCoordinates = ({ latitude, longitude } = {}) =>
  parseCoordinate(latitude) !== null &&
  parseCoordinate(longitude) !== null;

export const needsApartmentGeocoding = (
  apartment,
  resolvedAddressKey = ""
) =>
  !hasApartmentCoordinates(apartment) ||
  getApartmentAddressKey(apartment) !== resolvedAddressKey;

export const geocodeApartmentAddress = async (
  apartment,
  maps = globalThis.window?.google?.maps
) => {
  const address = buildApartmentGeocodeAddress(apartment);
  const hasAddressDetails = [
    apartment?.street,
    apartment?.streetNumber,
    apartment?.zip,
    apartment?.city,
  ].some((value) => cleanAddressPart(value));

  if (!hasAddressDetails) {
    throw new Error(
      "Συμπληρώστε τα στοιχεία της διεύθυνσης πριν από την αποθήκευση."
    );
  }

  if (!maps?.Geocoder) {
    throw new Error(
      "Η υπηρεσία γεωκωδικοποίησης δεν είναι διαθέσιμη αυτή τη στιγμή."
    );
  }

  try {
    const geocoder = new maps.Geocoder();
    const response = await geocoder.geocode({
      address,
      componentRestrictions: { country: "GR" },
      language: "el",
      region: "gr",
    });
    const location = response?.results?.[0]?.geometry?.location;
    const latitude =
      typeof location?.lat === "function" ? location.lat() : location?.lat;
    const longitude =
      typeof location?.lng === "function" ? location.lng() : location?.lng;

    if (
      parseCoordinate(latitude) === null ||
      parseCoordinate(longitude) === null
    ) {
      throw new Error("Δεν βρέθηκε η διεύθυνση στο Google Maps.");
    }

    return {
      latitude: parseCoordinate(latitude),
      longitude: parseCoordinate(longitude),
    };
  } catch (error) {
    if (error?.message?.includes("Δεν βρέθηκε η διεύθυνση")) throw error;
    throw new Error(
      "Δεν ήταν δυνατός ο εντοπισμός της διεύθυνσης στο Google Maps."
    );
  }
};
